import * as React from 'react';
import {SubTitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';
import type {MeetingStats} from '../../../utils/sequential';
import {BookingStats} from './booking-stats.tsx';
import css from './sequential-booking-info.css';


interface BookingInfoHeaderProps {
  title: string;
  brandLogo?: string;
  stats: MeetingStats;
}

export const BookingInfoHeader = ({
  title,
  brandLogo,
  stats,
}: BookingInfoHeaderProps) => {
  return (
    <div className={css.bookingInfoHeader}>
      <div className={css.bookingInfoLogo}>
        {brandLogo && (
          <img
            src={brandLogo}
            // eslint-disable-next-line @spaced-out/i18n/no-static-labels
            alt="agency logo"
            className={css.logoPreview}
          />
        )}
      </div>
      <div className={css.bookingTitle}>
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        <SubTitleMedium color="primary">{title || ''}</SubTitleMedium>
        <BookingStats stats={stats} />
      </div>
    </div>
  );
};
